<span class="inline-block max-w-[340px] truncate" [title]="cell() | mapToText">
  {{ cell() | mapToText }}
</span>
